import ouiStyle from '@goldwasserexchange/oui-style';
import * as React from 'react';
import { X } from 'react-feather';
import { NewsLetterErrorIconContainer } from './components';

export const NewsLetterErrorIcon = () => (
  <NewsLetterErrorIconContainer>
    <X color={ouiStyle.Constants.Colors.danger} size="5rem" />
  </NewsLetterErrorIconContainer>
);
